import { convertTimeStringWithDuration } from '_utils/functions/converter'

const DeliveryCardBody = ({ deliveryTime, deliveryDuration }) => (
  <div className={'body'}>
    <span>Delivery for {convertTimeStringWithDuration(deliveryTime, deliveryDuration)}</span>
  </div>
)

export default DeliveryCardBody
